import AddProjectAnnoucement from "./pages/ProjectAnnoucement/AddProjectAnnoucement";
import ProjectAnnoucementDetail from "./pages/ProjectAnnoucement/ProjectAnnoucementDetail";
import VendorsProjectAnnocement from "./pages/ProjectAnnoucement/VendorsProjectAnnocement";

export const Routes = {
    // pages
    // Presentation: { path: "/" },
    // Signin: { path: "/examples/sign-in" },

    Signin: { path: "/" },
    RegisterVendor: { path: "/RegisterVendor" },
    Notifications: { path: "/Notifications" },
    DashboardOverview: { path: "/dashboard/overview" },
    Timeoff:{path:'/timeoff'},
    TimeOffDetail:{path:'/timeoffDetail'},
    AddTimeOff:{path:'/AddTimeoff'},
    Vendors:{path:'/Vendors'},
    VendorDetail:{path:'/VendorsDetail'},
    AddVendor:{path:'/AddVendor'},
    AssetsDetail: { path: "/AssetsDetail" },
    AssetsAdd: { path: "/AddAssets" },
    Reminder: { path: "/Reminders" },
    AddReminder: { path: "/AddReminder" },
    ReminderDetail: { path: "/ReminderDetail" },
    Assets: { path: "/Assets" },
    Contracts: { path: "/Contracts" },
    ContractsAdd: { path: "/AddContracts" },
    ContractsDetail: { path: "/ContractsDetail" },
    ProjectAnnoucement: { path: "/ProjectAnnoucement" },
    AddProjectAnnoucement:{path:"/AddProjectAnnoucement"},
    ProjectAnnoucementDetail:{path:"/ProjectAnnoucementDetail"},
VendorsProjectAnnocement:{path:'/Vendors_ProjectAnnoucement'},
    FileManagement: { path: "/FileManagement" },
    Settings: { path: "/settings" },
 
    Billing: { path: "/examples/billing" },
    Invoice: { path: "/examples/invoice" },
    Signup: { path: "/examples/sign-up" },
    ForgotPassword: { path: "/examples/forgot-password" },
    ResetPassword: { path: "/examples/reset-password" },
    Lock: { path: "/examples/lock" },
    NotFound: { path: "/examples/404" },
    ServerError: { path: "/examples/500" },

  

};